import type { BranchMiniEntity } from "@/features/branch/domain/entities/BranchMiniEntity"
import type { ShowcaseType } from "../enums/ShowcaseType"
import type { ChannelMiniEntity } from "@/features/channel/domain/entities/ChannelMiniEntity"
import type { ItemMiniEntity } from "@/features/item/domain/entities/ItemMiniEntity"
import type { ScopeType } from "../enums/ScopeType"
import type { ShowcaseModeType } from "../enums/ShowcaseModeType"

export class ShowcaseFilterEntity {
    id?: number 
    name?: string 
    type?: ShowcaseType 
    channel?: ChannelMiniEntity 
    branch?: BranchMiniEntity 
    item?: ItemMiniEntity 
    page?: number 
    limit?: number 
    sortField?: string 
    sortDescending?: boolean 
    ignoreChannelOption?: boolean
    scopeType?: ScopeType
    mode?: ShowcaseModeType
}
